export default __webpack_public_path__ + "static/lilnadas-cards-story-1-89210dc59f182fdf33030f25a3f68656.png";